import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isCreateMultipleTaskModalVisible: false,
    response: {},
    created: null
  },
  getters: {
    getIsCreateMultipleTaskModalVisible: (state) => state.isCreateMultipleTaskModalVisible,
    response: state => state.response,
    created: (state) => state.created
  },
  mutations: {
    toggleCreateMultipleTaskModal (state) {
      state.isCreateMultipleTaskModalVisible = !state.isCreateMultipleTaskModalVisible
    },
    setResponse (state, payload) {
      state.response = payload
    },
    setCreated (state, created) {
      state.created = created
    }
  },
  actions: {
    async createMultipleTasksForCollection ({ commit, state }, params) {
      const response = await new ApiService(
        `e_x_c_m_cases/create_tasks_multi`
      ).post(params.body)
      commit('setCreated', await response.json())
      commit('setResponse', response)
    },
    reset (state) {
      state.isCreateMultipleTaskModalVisible = false
      state.response = {}
      state.created = null
    }
  }
}
